import React from 'react';
import PropTypes from 'prop-types';
import { numberToCurrency } from 'utils/currency';
import Alert from 'components/alert/Alert';
import useLocale from 'components/useLocale/useLocale';
import { createUseStyles } from '@glu/theming';
import styles from './PaymentConfirmationAlert.styles';

const useStyles = createUseStyles(styles);

const PaymentsConfirmationAlert = ({ balanceCheckType, dismissible, errors, onHide, title }) => {
  const locale = useLocale();
  const { alertTable } = useStyles();

  return (
    <Alert title={title} variant="error" onHide={onHide} details dismissible={dismissible}>
      <table className={alertTable}>
        <thead>
          <tr>
            <th>{locale['payments.payeeName']}</th>
            <th>{locale['payments.amount']}</th>
            <th>{locale['payments.reason']}</th>
          </tr>
        </thead>
        <tbody>
          {errors.map((error) => (
            <tr key={`${error.bankTrace || error.custTrace}`}>
              <td>{error.payeeName}</td>
              <td>{numberToCurrency(error.amount)}</td>
              <td>{error.reason}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Alert>
  );
};

PaymentsConfirmationAlert.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object).isRequired,
  onHide: PropTypes.node,
  locale: PropTypes.objectOf(PropTypes.string),
  balanceCheckType: PropTypes.string,
  title: PropTypes.string,
  dismissible: PropTypes.bool
};

PaymentsConfirmationAlert.defaultProps = {
  locale: {},
  balanceCheckType: '',
  title: '',
  dismissible: true,
  onHide: () => {}
};

export default PaymentsConfirmationAlert;
